<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<div class="ackb">
<p class="ack">Publisher: Amy Barrett-Daffin</p>
<p class="ack">Creative Director: Gailen Runge</p>
<p class="ack">Acquisitions Editor: Roxane Cerda</p>
<p class="ack">Managing Editor: Liz Aneloski</p>
<p class="ack">Editors: Liz McGehee, Judy Petry, and Ursula Reikes</p>
<p class="ack">Cover/Book Designer: April Mostek</p>
<p class="ack">Production Coordinator: Zinnia Heinzmann</p>
<p class="ack">Production Editor: Alice Mace Nakanishi</p>
<p class="ack">Illustrator: Linda Johnson</p>
<p class="ack">Photo Assistant: Lauren Herberg</p>
<p class="ack">Subject and instructional photography by Lauren Herberg of C&amp;T Publishing, Inc., unless otherwise noted</p>
<p class="ack">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</div>
<p class="figure-aligncenter-indent"><img src="images/pg3_4.jpg"/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0002_copy.vue?6e5a1249